import SNLogoSVG from "../../../images/_svgs/v2/logo.svg";

import SVGImage from "../../SVGImage";
import { useMemo } from "react";
import FooterNavigation from "./FooterNavigation";
import SocialLinks from "./SocialLinks";
import ContactUs from "./ContactUs";

const Footer = ({ showFooterNavigation = true }) => {
	const date = useMemo(() => {
		const d = new Date();
		return d.getFullYear();
	}, []);

	return (
		<>
			<footer id="footer" className="">
				{showFooterNavigation && <FooterNavigation />}
				<SocialLinks />
				<ContactUs />

				<div id="footer-container" className="py-10 py-md-20  container d-flex flex-column">
					<SVGImage style={{ width: "100%", height: "100%" }} alt="Stay Nimble" color="black">
						<SNLogoSVG />
					</SVGImage>
					<div className="pt-4 pt-md-7">
						©<span>{date}</span> Stay Nimble. All rights reserved.
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
